import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import { SavedQueryService } from "@app2/search/saved-query.service";
import { Observable } from "rxjs";
import { SavedQuery } from "@app2/type-defs/search/search-types";

@Component({
    selector: "saved-query-icon",
    template: `
            <ng-container *ngIf="savedQueryId && savedQuery$ | async as savedQuery">
                <svg-icon *ngIf="savedQuery.orgId !== null || savedQuery.libraryQueryId"
                          [inline]="true"
                          src="assets/icons/saved-query-label.svg"
                          class="saved-query-icon"
                          test-id="saved-query-icon">
                </svg-icon>
                <svg-icon *ngIf="savedQuery.orgId === null || savedQuery.libraryQueryId"
                          [inline]="true"
                          src="assets/icons/ds-label.svg"
                          class="library-query-icon"
                          test-id="library-query-icon">
                </svg-icon>
            </ng-container>
            <ng-container *ngIf="!savedQueryId">
                <svg-icon *ngIf="showSavedQueryIcon"
                          [inline]="true"
                          src="assets/icons/saved-query-label.svg"
                          class="saved-query-icon"
                          test-id="saved-query-icon">
                </svg-icon>
                <svg-icon *ngIf="showLibraryQueryIcon"
                          [inline]="true"
                          src="assets/icons/ds-label.svg"
                          class="library-query-icon"
                          test-id="library-query-icon">
                </svg-icon>
            </ng-container>
    `,
    styles: [`
        /* icon is 9x12 meaning width is 6 off */
        .saved-query-icon {
            display: inline-block;
            vertical-align: text-bottom;
            margin-right: 3px;
            width: 13.33px;
            height: 13.33px;
        }
        .library-query-icon {
            display: inline-block;
            vertical-align: text-bottom;
            margin-right: 3px;
            width: 13.33px;
            height: 13.33px;
        }
    `],
})
export class SavedQueryIconComponent implements OnChanges {
    @Input() savedQueryId: uuid;

    // prefer passing the id when possible
    // if id is not available then use these
    @Input() showSavedQueryIcon = false;
    @Input() showLibraryQueryIcon = false;

    savedQuery$: Observable<SavedQuery> = null;

    constructor(private savedQueryService: SavedQueryService) {
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.savedQueryId) {
            this.savedQuery$ = this.savedQueryService.getSavedQuery$(this.savedQueryId);
        }
    }
}
